<div class="ws-step">
  <div class="ws-step-header">
    <h3>Qualification Form</h3>
    <p class="text-muted">When your salesperson marks a lead as interested after a call, this form pops up to capture important details. These are the data points your team collects to qualify a lead.</p>
  </div>

  <div class="ws-step-body">
    @if (existingForm) {
      <div class="alert alert-success">
        <i class="bi bi-check-circle me-2"></i>
        A qualification form already exists: <strong>{{ existingForm.displayName }}</strong>
      </div>
    } @else {
      <!-- AI Feedback section at top -->
      <div class="ws-feedback-section mb-4">
        <div class="ws-feedback-label">Describe what your salespeople ask when a lead is interested, and AI will refine the form:</div>
        <textarea [(ngModel)]="feedback" placeholder="e.g. We need to capture loan amount, employment type, and CIBIL score"></textarea>
        <div class="ws-feedback-actions">
          <button class="btn btn-sm btn-outline-primary" (click)="submitFeedback()" [disabled]="!feedback.trim()">
            <i class="bi bi-stars me-1"></i> Regenerate with AI
          </button>
        </div>
      </div>

      <!-- Form fields list -->
      <div cdkDropList (cdkDropListDropped)="reorderFields($event)">
        @for (field of fields; track $index; let i = $index) {
          <div class="ws-item-card" [ngClass]="{'selected': field.included}" cdkDrag>
            <i class="bi bi-grip-vertical ws-drag-handle" cdkDragHandle></i>
            <input type="checkbox" class="form-check-input ws-item-toggle" [checked]="field.included" (change)="toggleField(field)" />
            <div class="ws-item-content">
              <div class="d-flex align-items-center gap-2">
                <span class="badge bg-secondary-subtle text-secondary">{{ i + 1 }}</span>
                <span class="ws-item-name">{{ field.name }}</span>
                <span class="ws-chip ws-chip-type">{{ field.type }}</span>
                @if (field.isNew) {
                  <span class="badge bg-primary-subtle text-primary">New</span>
                }
              </div>
              @if (field.type === 'Option' && field.options?.length) {
                <div class="ws-item-meta mt-1">Options: {{ field.options.join(', ') }}</div>
              }
              <div class="ws-item-meta mt-1">
                <label class="form-check form-check-inline" style="position: relative;">
                  <input type="checkbox" class="form-check-input" style="position: static !important; margin: 0 4px 0 0 !important; width: 14px; height: 14px;" [checked]="field.isMandatory" (change)="toggleMandatory(field)" />
                  <span class="form-check-label" style="font-size: 12px;">Required</span>
                </label>
              </div>
            </div>
            <button class="btn btn-sm btn-link text-danger" (click)="removeField(field)"><i class="bi bi-x-lg"></i></button>
          </div>
        }
      </div>

      @if (!fields.length) {
        <div class="ws-empty-state">
          <i class="bi bi-ui-checks"></i>
          <p>No fields yet. Describe what your team needs above or add fields manually below.</p>
        </div>
      }

      <!-- Add new field -->
      <div class="d-flex align-items-center gap-2 mt-3">
        <input class="form-control form-control-sm" [(ngModel)]="newFieldName" placeholder="Add new field..." (keyup.enter)="addField()" />
        <select class="form-select form-select-sm" style="width: 120px;" [(ngModel)]="newFieldType">
          <option value="Text">Text</option>
          <option value="Number">Number</option>
          <option value="Option">Option</option>
          <option value="DateTime">Date</option>
        </select>
        <button class="btn btn-sm btn-outline-primary" (click)="addField()" [disabled]="!newFieldName.trim()">Add</button>
      </div>
      <div class="ws-item-meta mt-1">Fields added here will be created as custom contact properties and included in the form.</div>
    }

    <div class="ws-save-row">
      <button mat-raised-button color="primary" (click)="save()" [disabled]="isSaving">
        @if (isSaving) {
          <span class="spinner-border spinner-border-sm me-1"></span>
        }
        {{ existingForm ? 'Continue' : 'Create Form & Continue' }}
      </button>
    </div>
  </div>
</div>
